import * as tslib_1 from "tslib";
import { NbDialogRef } from '@nebular/theme';
import { map } from 'rxjs/operators';
import { DeviceService } from '@app/models/devices/devices.service';
import { DataComponent } from '@app/utils/data.component';
import { LocationService } from '@app/models/locations/locations.service';
var LocationSelectorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LocationSelectorComponent, _super);
    function LocationSelectorComponent(dialog, devices, locations) {
        var _this = _super.call(this) || this;
        _this.dialog = dialog;
        _this.devices = devices;
        _this.locations = locations;
        return _this;
    }
    LocationSelectorComponent.prototype.fetch = function () {
        var _this = this;
        return this.locations.getAll({ list_shared: true, profile: true }).pipe(map(function (data) { return _this.LOCATION_SORT(data, _this.userID); }), this.devices.joinLocationsPipe());
    };
    LocationSelectorComponent.prototype.selectLocation = function (loc) {
        this.dialog.close(loc);
    };
    return LocationSelectorComponent;
}(DataComponent));
export { LocationSelectorComponent };
